import React from 'react';
import { Row, Col } from 'reactstrap';
import {ParallaxLayersControl} from './AdDesignExtraControls';
import SubCard from '../base/components/SubCard';
// import { FCard, FilterForm, FPropControl } from '../base/components/FilterUI';
import C from '../C';
import PropControl from '../base/components/PropControl';
import Advert from '../base/data/Advert';
import KStatus from '../base/data/KStatus';
import { space } from '../base/utils/miscutils';
import { CharityForm } from './CharityControls';
//import Wizard, {WizardStage} from '../base/components/WizardProgressWidget';
import { PreviewDisplayAd, actionCount, previewCol } from './DisplayAdvertUtils';
import Misc from '../base/components/Misc';

function CauseControlsPage({advert, path, size}) {
	const dpath = [...path, 'displayBase'];
	const bpath = [...path, 'branding'];
	const dbpath = [...path, 'displayBase', 'branding'];

	let dBase = advert.displayBase;
	if(!dBase) return <Misc.Loading />;

	if (!dBase.action) dBase.action = "plants trees";

	let branding = advert.branding;

	const charitiesList = Advert.charityList(advert);
	const charity = charitiesList[0];

	let demoNumber = actionCount({path:path, useDemoNumber:true}); //advert.advanced.demoNumber === "" ? 1000 : advert.advanced.demoNumber; 

	return (
		<>
		<Col className="content-col">
			<h1>Format Controls</h1>
			
			<h2>Cause</h2>
			<CharityForm entity={advert} charity={charity} i={0} />

			<br /><h2>Customize</h2>
			<SubCard className="cause-text-editor m-1" style={{color: branding.color, backgroundColor: branding.backgroundColor, padding:"5% 0"}}>
				<small>The advert will cycle between these two cards</small>
				<p style={{color: branding.color, backgroundColor: branding.color2, padding:"2.5% 0"}}>THIS AD <PropControl required path={dpath} prop="action" inline help="This ad *Does an action*" placeholder="action"/><br/><PropControl type="checkbox" label="Inline blocks" prop="inlineText1" path={[...path, "advanced"]}/></p>
				<p style={{color: branding.color, backgroundColor: branding.color2, padding:"2.5% 0"}}>{actionCount({path:path, useDemoNumber:true})}<PropControl required path={dpath} prop="noun" inline help="What does this ad do good for? People, trees, coral, ect..." placeholder="noun"/>
				<PropControl required path={dpath} prop="verb" inline help="What does this ad do? Planting, donating, ect..." placeholder="verb"/><PropControl type="checkbox" label="Inline blocks" prop="inlineText2" path={[...path, "advanced"]}/></p>
			</SubCard>
			<br />
			<Row>
				<Col><PropControl type="color" path={bpath} prop="color" label="Text color"/></Col>
				<Col><PropControl type="color" path={bpath} prop="color2" label="Text background color"/></Col>
			</Row>
			<br/>

			<br /><h2>Advert Background</h2>
			<Row>
				<Col><PropControl required type="imgUpload" path={bpath} prop="backgroundImage" label="Custom background"/></Col>
				<Col><PropControl required type="color" path={bpath} prop="backgroundColor" label="Background color"/></Col>
			</Row>

			<br /><h2>Layer Controls</h2>
			<p>Add in images behind or in front of creative</p>
			<h5>Background</h5>
			<ParallaxLayersControl path={[...path, "advanced", "bg"]} />
			<h5>Foreground</h5>
			<ParallaxLayersControl path={[...path, "advanced", "fg"]} fg/>
			<br/>
			
			<br /><h2>Extra Controls</h2>
			<Row>
			<Col><PropControl label="Template Owner" path={[...path, "displayBase"]} prop="templatePermissionId" type="DataItem" pageSize={10} status={KStatus.PUB_OR_DRAFT} itemType={C.TYPES.Advertiser} 
				help="Templates default to being visible to every advert of the same size. If you want to hide a template and only allow ads of a specific brand to access them, enter the brand here."/></Col>
			</Row>
		</Col>
		{previewCol({ad:advert, path:path})}
		</>
	);
}

function AdvancedPage({ advert, path, size }) {
	const bpath = [...path, 'branding'];

	return (<>
		<Col className="content-col">
			<SubCard title="Custom Components" className="mx-5">
				<div className={space('advanced-layout', size) || "responsive"}>
					<div className="flex-grow-1 pr-5">
						<Col>
							<PropControl type="code" popup help="test" className="flex-grow-1" lang="html" path={bpath} prop="customHtml" style={{minHeight:"45vh"}} label="HTML"/>
							<PropControl type="code" popup className="flex-grow-1" lang="css" path={bpath} prop="customCss" style={{minHeight:"45vh"}} label="CSS"/>
						</Col>
					</div>
				</div>
			</SubCard>
			<SubCard title="Events" className="mx-5">
				<p><small>URLs (e.g. pixels) or scripts to be called on ad events</small></p>
				<div className="d-flex flex-column justify-content-center events">
					<PropControl type="code" popup className="flex-grow-1" lang="html" help="Can either be a url to be called or can be a HTML script tag. Will be called on ad rendering on a page." path={path.concat("advanced")} prop="onrender" label="On Render"/>
					<PropControl type="code" popup className="flex-grow-1" lang="html" help="Can either be a url to be called or can be a HTML script tag. Will be called on user clicking on your creative." path={path.concat("advanced")} prop="onclick" label="On Click"/>
				</div>
			</SubCard>
		</Col>
		{previewCol({ad:advert, path:path})}
	
		</>
	);
}

export {CauseControlsPage, AdvancedPage};
